import React from 'react';

import classes from 'src/shared/ui/scan-line/scan-line.module.scss';

const ScanLine: React.FC = () => {
  return <div className={classes.ScanLine} />;
};

export default ScanLine;
